import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { SupportTicket, SupportTicketMessage, SupportTicketStatus, SupportTicketType } from '../domain/support-ticket.model';
import { Page } from '../domain/page.model';
import { HttpUtils } from '../utils/http-utils';
import { PublisherTier } from '../domain/publisher.model';

@Injectable()
export class AdStatsSupportTicketsService {

  path = `${environment.serviceUrl}/ad-stats/support-tickets`;

  constructor(private http: HttpClient) {
  }

  getAll(filter: SupportTicketListRequest): Observable<Page<SupportTicket>> {
    return this.http.get<Page<SupportTicket>>(`${this.path}`, {
      params: HttpUtils.getHttpParams(filter)
    });
  }

  export(filter: SupportTicketListRequest) {
    return this.http.get(`${this.path}/export`, {
      responseType: 'text',
      params: HttpUtils.getHttpParams(filter)
    });
  }

  getCountByStatus(publisherId?: string): Observable<SupprtTicketCountByStatus[]> {
    return this.http.get<SupprtTicketCountByStatus[]>(`${this.path}/count`, {
      params: HttpUtils.getHttpParams({
        publisherId: publisherId
      })
    });
  }

  get(id: number): Observable<SupportTicket> {
    return this.http.get<SupportTicket>(`${this.path}/${id}`, {
      params: HttpUtils.getHttpParams({
        includeMessages: true
      })
    });
  }

  create(ticket: SupportTicket, message: SupportTicketMessage, files: File[]): Observable<SupportTicket> {
    const formData: FormData = new FormData();
    if (files && files.length) {
      formData.append('file', files[0], files[0].name);
    }
    formData.append('ticket', JSON.stringify(ticket));
    formData.append('message', JSON.stringify(message));
    return this.http.post<SupportTicket>(`${this.path}`, formData);
  }

  updateTicket(s: SupportTicket): Observable<SupportTicket> {
    return this.http.put<SupportTicket>(`${this.path}/${s.id}`, s);
  }

  saveMessage(ticket: SupportTicket, message: SupportTicketMessage, files: File[]) {
    const formData: FormData = new FormData();
    if (files && files.length) {
      formData.append('file', files[0], files[0].name);
    }
    formData.append('message', JSON.stringify(message));
    return this.http.post<SupportTicket>(`${this.path}/${ticket.id}/message`, formData);
  }
}

export class SupportTicketListRequest {
  page: number;
  size: number;
  publisherId?: string;
  publisherTier?: PublisherTier;
  userEmail?: string;
  urgent?: boolean;
  userName?: string;
  assigneeEmail?: string;
  sortDirection?: 'ASC' | 'DESC';
  sortProperty?: string;
  type?: SupportTicketType[];
  status?: SupportTicketStatus[];
}

export class SupprtTicketCountByStatus {
  status: SupportTicketStatus;
  count: number;
}
